import { TOAST_INFO, TOAST_WARNING, TOAST_SUCCESS, TOAST_ERROR } from './types';
import { ThunkAction } from 'redux-thunk';
import { AppState } from '$/store';
import * as Bixby from '$/core';
import { toast, ToastContent, ToastOptions } from 'react-toastify';

export const toastInfoAction = () => {
  return { type: typeof TOAST_INFO };
};
export const toastWarningAction = () => {
  return { type: typeof TOAST_WARNING };
};
export const toastSuccessAction = () => {
  return { type: typeof TOAST_SUCCESS };
};
export const toastErrorAction = () => {
  return { type: typeof TOAST_ERROR };
};

const mergeOptions = (options?: ToastOptions | undefined) => {
  const base: ToastOptions = {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    draggable: false,
    pauseOnHover: true,
    className: 'bix_toast',
  };
  const merged = options ? { ...base, ...options } : { ...base };
  return merged;
};

export const bottomBanner =
  (
    content: ToastContent,
    options?: ToastOptions | undefined
  ): ThunkAction<void, AppState, null, Bixby.Models.BixbyAction> =>
  dispatch => {
    const toastOptions: ToastOptions = { ...mergeOptions(options), type: 'info' };
    toast(content, toastOptions);
    dispatch(toastInfoAction());
  };

export const toastInfo =
  (
    content: ToastContent,
    options?: ToastOptions | undefined
  ): ThunkAction<void, AppState, null, Bixby.Models.BixbyAction> =>
  dispatch => {
    if (!options) {
      options = {};
    }
    options.type = 'info';
    const toastOptions: ToastOptions = { ...mergeOptions(options), type: 'info' };
    toast(content, toastOptions);
    dispatch(toastInfoAction());
  };

export const toastWarning =
  (
    content: ToastContent,
    options?: ToastOptions | undefined
  ): ThunkAction<void, AppState, null, Bixby.Models.BixbyAction> =>
  dispatch => {
    const toastOptions: ToastOptions = { ...mergeOptions(options), type: 'warning' };
    toast(content, toastOptions);

    dispatch(toastWarningAction());
  };

export const toastSuccess =
  (
    content: ToastContent,
    options?: ToastOptions | undefined
  ): ThunkAction<void, AppState, null, Bixby.Models.BixbyAction> =>
  dispatch => {
    const toastOptions: ToastOptions = { ...mergeOptions(options), type: 'success' };
    toast(content, toastOptions);

    dispatch(toastSuccessAction());
  };

export const toastError =
  (
    content: ToastContent,
    options?: ToastOptions | undefined
  ): ThunkAction<void, AppState, null, Bixby.Models.BixbyAction> =>
  dispatch => {
    const toastOptions: ToastOptions = { ...mergeOptions(options), type: 'error' };
    toast(content, toastOptions);

    dispatch(toastErrorAction());
  };
